import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { es } from './es';
import { de } from './de';
import { fr } from './fr';
import { frCa } from './fr-ca';
import { ja } from './ja';

export const defaultNS = 'common';
export const resources = { en, es, de, fr, frCa, ja } as const;

export const i18n = i18next.use(initReactI18next);

i18n.init({
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
